import { EventClickArg } from '@fullcalendar/core';
import allLocales from '@fullcalendar/core/locales-all';
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import FullCalendar from '@fullcalendar/react';
import { useEffect, useRef, useState } from 'react';
import { SchedulingByDataModel } from '../../../../models/requests-management/workshift&Interruption';
import { convertToEvents } from '../../utils';
import {
    DataInfo,
    DataInfoExtendedProps,
    DetailsModal,
} from '../modals/DetailsModal';
import interactionPlugin, { DateClickArg } from '@fullcalendar/interaction';

interface DesktopCalendarProps {
    schedulings: SchedulingByDataModel[];
    prevMonth: () => void;
    nextMonth: () => void;
    currentDate: Date;

    handlerCreateRequestFromButton: (
        type: string,
        startDate: string,
        endDate: string,
        startHour: string,
        endHour: string,
        info?: DataInfoExtendedProps
    ) => void;
}
export const DesktopCalendar = ({
    schedulings,
    handlerCreateRequestFromButton,
    nextMonth,
    prevMonth,
    currentDate,
}: DesktopCalendarProps) => {
    const [isOpenDetails, setIsOpenDetails] = useState(false);
    const [detailsInfo, setDetailsInfo] = useState<DataInfo>({} as DataInfo);
    const [convertedEvents, setConvertedEvents] = useState([]);
    const [date, setDate] = useState(currentDate);

    const calendarRef = useRef(null);

    const handleNewEventByDate = (arg: DateClickArg) => {
        let date = arg.dateStr + 'T00:00';

        let event: DataInfo = {
            start: date,
            end: date,
            className: '',
            title: '',
            extendedProps: {
                date: date,
            },
        } as DataInfo;

        handlerCreateRequestFromButton(
            event.className,
            event.start,
            event.end,
            event.extendedProps.startTime ?? '',
            event.extendedProps.endTime ?? ''
        );
    };

    /**
     * Handling click on event on calendar
     */
    const handleEventClick = (arg: EventClickArg) => {
        const newEvent = arg.event;
        const eventProps = newEvent._def.extendedProps;
        const st_date = date_r(newEvent.start?.toString());

        let event: DataInfo = {} as DataInfo;

        if (eventProps.className === 'workshift') {
            event = {
                className: eventProps.className,
                title: eventProps.workshiftName,
                start: st_date?.replaceAll('/', '-') ?? '',
                end: st_date?.replaceAll('/', '-') ?? '',
                extendedProps: {
                    documentNumber: eventProps?.documentNumber,
                    employee: eventProps?.employee,
                    isDuplex: eventProps?.isDuplex,
                    isExceptional: eventProps?.isExceptional,
                    isNextDay: eventProps?.isNextDay,
                    workshiftName: eventProps?.workshiftName,
                    date: eventProps?.date,
                    startTime: eventProps?.startTime,
                    endTime: eventProps?.endTime,
                    startTime2: eventProps.startTime,
                    endTime2: eventProps.endTime,
                    observations: '',
                    hasAvailability: eventProps?.hasAvailability,
                    personId: eventProps?.personId,
                    interruptionId: eventProps?.interruptionId,
                    workshiftId: eventProps?.workshiftId,
                    interruptionName: eventProps?.interruptionName,
                    interruptionTypeId: eventProps?.interruptionTypeId,
                    isAdditionalHour: eventProps?.isAdditionalHour,
                    costCenters: eventProps?.costCenters,
                    operationCenters: eventProps?.operationCenters
                },
            };
        } else {
            event = {
                className: eventProps.className,
                title: newEvent._def.title,
                start: eventProps?.date.split('T')[0] + 'T00:00:00' ?? '',
                end: eventProps?.date.split('T')[0] + 'T00:00:00' ?? '',
                extendedProps: {
                    documentNumber: eventProps?.documentNumber,
                    employee: eventProps?.employee,
                    date: eventProps?.date,
                    endTime: eventProps?.endTime,
                    startTime: eventProps?.startTime,
                    endTime2: '',
                    startTime2: '',
                    observations: eventProps?.observations,
                    isDuplex: false,
                    isExceptional: false,
                    isNextDay: false,
                    workshiftName: eventProps?.workshiftName,
                    hasAvailability: eventProps?.hasAvailability,
                    personId: eventProps?.personId,
                    interruptionId: eventProps?.interruptionId,
                    interruptionName: eventProps?.interruptionName,
                    workshiftId: eventProps?.workshiftId,
                    interruptionTypeId: eventProps?.interruptionTypeId,
                    isAdditionalHour: eventProps?.isAdditionalHour,
                    costCenters: eventProps?.costCenters,
                    operationCenters: eventProps?.operationCenters
                },
            };
        }
        setIsOpenDetails(true);
        setDetailsInfo(event);
    };

    const date_r = function formatDate(date: string | undefined) {
        if (date) {
            var d = new Date(date),
                month = '' + (d.getMonth() + 1),
                day = '' + d.getDate(),
                year = d.getFullYear();
            if (month.length < 2) month = '0' + month;
            if (day.length < 2) day = '0' + day;
            return [year, month, day].join('-');
        }
    };

    useEffect(() => {
        const res = convertToEvents(schedulings);
        setConvertedEvents(res);
    }, [schedulings, date]);

    return (
        <div className='mt-3'>
            <FullCalendar
                initialDate={date}
                locales={allLocales}
                locale={'es'}
                height={'72vh'}
                themeSystem='bootstrap'
                headerToolbar={{
                    right: 'title',
                    center: '',
                    left: 'custom2,custom1', // user can switch between the two
                }}
                plugins={[dayGridPlugin, interactionPlugin]}
                initialView='dayGridMonth'
                ref={calendarRef}
                events={convertedEvents}
                eventClick={(arg) => handleEventClick(arg)}
                dateClick={(arg) => handleNewEventByDate(arg)}
                customButtons={{
                    custom1: {
                        text: '>',
                        click: (ev, element) => {
                            nextMonth();
                            // @ts-ignore
                            let calendarApi = calendarRef!.current!.getApi();
                            calendarApi.prev();
                        },
                    },
                    custom2: {
                        text: '<',

                        click: (ev, element) => {
                            prevMonth();
                            // @ts-ignore
                            let calendarApi = calendarRef!.current!.getApi();
                            calendarApi.next();
                        },
                    },
                }}
            />

            {isOpenDetails && (
                <DetailsModal
                    handlerCreateRequestFromButton={handlerCreateRequestFromButton}
                    isOpen={isOpenDetails}
                    onClose={setIsOpenDetails}
                    detailsInfo={detailsInfo}
                />
            )}
        </div>
    );
};
